import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchApplicationDropdownData, fetchApplicationProductName, fetchApplicationDropdown, postApplicationData, fetchApplicationGrid, updateApplicationGridView, deleteApplicationGridView, approveApplicationGridView, fetchSeedsUnitsDropdown, getCropsData } from "../services/productcostapplication.api";
import { GenericDropdownItem, PriceDropdownItem, ProductDropdownItem, QuantityUnitDropdownItem, RateUnitDropdownItem } from '../types/productcostapplication'
import {
  createProductPrices,
  GetproductPurchaseUnits,
  updateProductPrices,
} from "../services/productcostseed.api";
import { toast } from "react-toastify";

type CalYear = {
  year: number;
};
type Activity = {
  activity: string;
};

type Crop = {
  id: number;
  cropName: string;
}
interface ApplicationDropdownState {
  calYear: CalYear[];
  activity: Activity[];
  productType: string[];
  product: ProductDropdownItem[];
  gernericName: GenericDropdownItem[];
  price: PriceDropdownItem[];
  quantityUnit: QuantityUnitDropdownItem[];
  rateUnit: RateUnitDropdownItem[];
  priceUnit: PriceDropdownItem[];
  gridData: [];
  responsebool: boolean;
  deleteresonse: boolean;
  loading: boolean;
  error: string | null;
  selectedId: number | null;
  menuName: string | null;
  approveresponse: boolean;
  modifyresponse: boolean;
  selectedApproveRecord: any;
  recordData: any;
  currentaddedData: any;
  products: any;
  productPurchasedUnits: any[];
  unitsPeriods: any[];
  seedsCostUnits: any[];
  cropTypesArray: Crop[];
}

const initialState: ApplicationDropdownState = {
  calYear: [],
  activity: [],
  productType: [],
  product: [],
  gernericName: [],
  price: [],
  quantityUnit: [],
  rateUnit: [],
  priceUnit: [],
  gridData: [],
  loading: false,
  error: null,
  responsebool: false,
  deleteresonse: false,
  selectedId: null,
  menuName: null,
  approveresponse: false,
  modifyresponse: false,
  selectedApproveRecord: null,
  recordData: [],
  currentaddedData: [],
  products: [],
  productPurchasedUnits: [],
  unitsPeriods: [],
  seedsCostUnits: [],
  cropTypesArray: []
};

export const fetchDropdown = createAsyncThunk(
  "applicationdropdown/fetch",
  async (dropdownType: string) => {
    const response = await fetchApplicationDropdownData(dropdownType);
    return response.data;
  }
);

export const fetchSeedsUnitsDropdownPeriods = createAsyncThunk(
  "fetchUnits",
  async(data: any) => {
    const response = await fetchSeedsUnitsDropdown(data);
    return response.data;
  }
);

export const fetchCropTypes = createAsyncThunk(
  "getCropsUnits",
  async(data: any) => {
    const response = await getCropsData(data);
    return response.data;
  }
);

export const fetchProductNameDropdown = createAsyncThunk(
  "applicationproductdropdown/fetch",
  async ({ value, calyear }: { value: string; calyear: number }) => {
    const response = await fetchApplicationProductName(value, calyear);
    return response.data;
  }
);

export const fetchProductApplicationDropdown = createAsyncThunk(
  "productapplicationdropdown/fetch",
  async ({ type, value }: { type: string; value: number }) => {
    const response = await fetchApplicationDropdown(type, value);
    return response.data;
  }
);

export const postProductApplicationDropdown = createAsyncThunk(
  "productapplicationdropdown/post",
  async (value: any) => {
    const response = await postApplicationData(value);
    return response.data;
  }
);

export const postProductApplicationGrid = createAsyncThunk(
  "productapplicationgrid/fetch",
  async (value: any) => {
    const response = await fetchApplicationGrid(value);
    return response.data;
  }
);

export const updateProductApplicationGridView = createAsyncThunk(
  "productapplicationgrid/update",
  async (value: any) => {
    const response = await updateApplicationGridView(value);
    return response.data;
  }
);

export const updateProductPricesData = createAsyncThunk(
  "product/pricing",
  async (data: any) => {
    const response = await updateProductPrices(data);
    return response.data;
  }
);

export const createProductPricesData = createAsyncThunk(
  "product/pricing/create",
  async (data: any) => {
    const response = await createProductPrices(data);
    return response.data;
  }
);

export const fetchProductPriceUnits = createAsyncThunk(
  "product/units",
  async () => {
    const response = await GetproductPurchaseUnits();
    return response.data;
  }
);
export const approveProductApplicationGridView = createAsyncThunk(
  "productapplicationgrid/updated",
  async (value: any) => {
    const response = await approveApplicationGridView(value);
    return response.data;
  }
);

export const deleteProductApplicationGrid = createAsyncThunk(
  "productapplicationgrid/delete",
  async (value: any) => {
    const response = await deleteApplicationGridView(value);
    return response.data;
  }
);
const applicationdropdownSlice = createSlice({
  name: "applicationdropdown",
  initialState,
  reducers: {
    setSelectedId: (state, action) => {
      state.selectedId = action.payload;
    },
    setSelectedApproveRecord: (state, action) => {
      state.selectedApproveRecord = action.payload;
    },
    setMenuName: (state, action) => {
      state.menuName = action.payload;
    },
    resetapproveresponse: (state) => {
      state.approveresponse = false;
    },
    resetmodifyresponse: (state) => {
      state.modifyresponse = false;
    },
    setCurrentAddedData: (state, action) => {
      state.currentaddedData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDropdown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDropdown.fulfilled, (state, action) => {
        state.loading = false;
        if (action.meta.arg === "calYear") {
          state.calYear = action.payload;
        } else if (action.meta.arg === "activity") {
          state.activity = action.payload;
        } else if (action.meta.arg === "productType") {
          state.productType = action.payload;
        }
      })
      .addCase(fetchDropdown.rejected, (state) => {
        state.loading = false;
        state.error = "Failed to fetch dropdown data.";
      })
      .addCase(fetchProductNameDropdown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCropTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.cropTypesArray = action.payload;
      })
      .addCase(fetchProductNameDropdown.fulfilled, (state, action) => {
        state.loading = false;
        state.product = action.payload;
      })
      .addCase(fetchSeedsUnitsDropdownPeriods.fulfilled, (state,action)=> {
        state.loading = false;
        state.seedsCostUnits = action.payload;
      })
      .addCase(fetchProductNameDropdown.rejected, (state) => {
        state.loading = false;
        state.error = "Failed to fetch dropdown data.";
      })
      .addCase(fetchProductApplicationDropdown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductApplicationDropdown.fulfilled, (state, action) => {
        state.loading = false;
        if (action.meta.arg.type === "genericName") {
          state.gernericName = action.payload;
        } else if (action.meta.arg.type === "price") {
          state.price = action.payload;
        } else if (action.meta.arg.type === "quantityUnits") {
          state.quantityUnit = action.payload;
        } else if (action.meta.arg.type === "rateUnits") {
          state.rateUnit = action.payload;
        } else if (action.meta.arg.type === "priceUnits") {
          state.priceUnit = action.payload;
        }
      })
      .addCase(fetchProductApplicationDropdown.rejected, (state) => {
        state.loading = false;
        state.error = "Failed to fetch dropdown data.";
      })
      .addCase(postProductApplicationGrid.fulfilled, (state, action) => {
        state.loading = false;
        state.gridData = action.payload;
      })
      .addCase(postProductApplicationDropdown.fulfilled, (state, action) => {
        state.loading = false;
        state.responsebool = !state.responsebool;
        state.recordData = action.payload;
      })
      .addCase(deleteProductApplicationGrid.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.selectedId = null;
      })
      .addCase(deleteProductApplicationGrid.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "An error occurred";
      })
      .addCase(updateProductPricesData.fulfilled, () => {
        toast.success("Product prices updated successfully.");
      })
      .addCase(createProductPricesData.fulfilled, () => {
        toast.success("Product prices added successfully.");
      })
      .addCase(updateProductPricesData.rejected, () => {
        toast.error("Failed to update product prices. Please try again.");
      })
      .addCase(createProductPricesData.rejected, () => {
        toast.error("Failed to add product prices. Please try again.");
      })
      .addCase(approveProductApplicationGridView.fulfilled, (state) => {
        state.loading = false;
        state.approveresponse = !state.approveresponse;
      })
      .addCase(updateProductApplicationGridView.fulfilled, (state) => {
        state.loading = false;
        state.modifyresponse = !state.modifyresponse;
      })
      .addCase(fetchProductPriceUnits.fulfilled, (state, action) => {
        state.loading = false;
        state.productPurchasedUnits = action.payload;
      });
  },
});

export const { setSelectedId, setMenuName, resetmodifyresponse, resetapproveresponse, setSelectedApproveRecord, setCurrentAddedData } = applicationdropdownSlice.actions;
export default applicationdropdownSlice.reducer;

